export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS'
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR'
export const UPDATE_PROVIDER_PRACTICING_STATES = 'UPDATE_PROVIDER_PRACTICING_STATES'

export const GET_ME = 'GET_ME'

export const START_SYNC = 'START_SYNC'
export const STOP_SYNC = 'STOP_SYNC'
